import { Component, signal } from "@angular/core";


@Component({
  selector: 'fini-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.scss'],
  standalone: false
})
export class LoginFooterComponent {
  year = signal(new Date().getFullYear());

  openHelpMenu() {
    console.log('openHelpMenu event from: login-footer');
    window.dispatchEvent(new CustomEvent('openHelpMenu', {
      detail: {
        from: 'login-footer',
      }
    }));
  }
}
